import { render, staticRenderFns } from "./ChargeDetail.vue?vue&type=template&id=019571ce&scoped=true"
import script from "./ChargeDetail.vue?vue&type=script&lang=js"
export * from "./ChargeDetail.vue?vue&type=script&lang=js"
import style0 from "./ChargeDetail.vue?vue&type=style&index=0&id=019571ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019571ce",
  null
  
)

export default component.exports